import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { BaseServicesService } from './services/base-services/base-services.service';
import { LoggingService } from './services/consoleLogs';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { DOCUMENT } from '@angular/common';
import { BrandingService } from './services/base-services/branding.service';
import { TenantUIResponse } from './models/tenant.model';
import { PermissionService } from './services/base-services/permission.service';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  // title = 'Careclinics | LMS';
  sessionUuid: string | null = null;
  logoWidth!: string;
  logoHeight!: string; loading: boolean = true;
  loginPath: string = ''; tenantUI!: TenantUIResponse;
  constructor(
    private baseServicesService: BaseServicesService,
    private permissionService: PermissionService,
    private loggingService: LoggingService,
    private meta: Meta, private title: Title,
    private titleService: Title,
    private brandingService: BrandingService,
    private cdr: ChangeDetectorRef,

    private metaService: Meta,
    private router: Router,
    @Inject(DOCUMENT) private doc: Document
  ) {


  }


  ngOnInit(): void {
    this.brandingService.setFavicon();
    this.brandingService.setMetaTags();
    this.loadTenantUI();

    const token = localStorage.getItem('authToken');
    if (token) {
      this.permissionService.loadFromCache();
    }
    this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe(() => {
        const authToken = localStorage.getItem('authToken');
        if (authToken) {
          this.permissionService.refreshPermissions(); // ✅ Always refresh
        }
      });
    // ✅ Watch for route changes (only when logged in)
    // this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
    //   const authToken = localStorage.getItem('authToken');
    //   if (authToken) {
    //     const now = Date.now();
    //     if (now - this.lastPermissionRefresh > 5 * 60 * 1000) { // every 5 mins
    //       this.permissionService.refreshPermissions();
    //       this.lastPermissionRefresh = now;
    //     }
    //   }
    // });

  }



  private loadTenantUI(): void {
    this.loggingService.log("private loadTenantUI app component")
    const cachedData = localStorage.getItem('tenantUI');
    if (cachedData) {
      this.applyTenantUI(JSON.parse(cachedData));
      this.loading = false;
      return;
    }

    this.baseServicesService.getTenantUI().subscribe({
      next: (data: TenantUIResponse) => {
        this.tenantUI = data;

        localStorage.setItem('tenantUI', JSON.stringify(data));
        this.applyTenantUI(data);
        this.loading = false;  // hide spinner
      },
      error: (err) => {
        this.loggingService.error('Error fetching tenant UI:', err);
        this.loading = false;
      }
    });
  }

  private applyTenantUI(data: TenantUIResponse): void {
    const branding = data.data.portalConfig.branding;

    // Loop over branding keys and set CSS vars
    Object.keys(branding).forEach((key) => {
      if (typeof (branding as any)[key] === 'string') {
        const cssVarName = `--${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
        document.documentElement.style.setProperty(
          cssVarName,
          (branding as any)[key]
        );
      }
    });

    // ✅ Define a derived hover color for launch button
    if (branding.launchButton) {
      const hoverColor = this.shadeColor(branding.launchButton, -15); // darken ~15%
      document.documentElement.style.setProperty('--launch-button-hover', hoverColor);
    }

    // ✅ NEW: Create gradient variables for primary button
    if (branding.primaryButton) {
      this.createGradientVariables(branding.primaryButton);
    }

    // ✅ Keep logo logic
    if (branding.logo?.url) {
      this.loginPath = branding.logo.url;
    }
  }

  private createGradientVariables(baseColor: string): void {
    // Create lighter and darker variants for gradient
    const lighterVariant = this.shadeColor(baseColor, 20); // 20% lighter
    const darkerVariant = this.shadeColor(baseColor, -20); // 20% darker

    // Set gradient variables
    document.documentElement.style.setProperty('--primary-button-gradient-light', lighterVariant);
    document.documentElement.style.setProperty('--primary-button-gradient-dark', darkerVariant);

    // Set complete gradient CSS variables
    document.documentElement.style.setProperty(
      '--primary-button-gradient',
      `linear-gradient(135deg, ${lighterVariant}, ${baseColor}, ${darkerVariant})`
    );

    document.documentElement.style.setProperty(
      '--primary-button-gradient-horizontal',
      `linear-gradient(90deg, ${lighterVariant}, ${darkerVariant})`
    );

    document.documentElement.style.setProperty(
      '--primary-button-gradient-vertical',
      `linear-gradient(180deg, ${lighterVariant}, ${darkerVariant})`
    );
  }

  private shadeColor(color: string, percent: number): string {
    // Handle both hex and rgb colors
    let R, G, B;

    if (color.startsWith('#')) {
      // Hex color
      const hex = color.replace('#', '');
      R = parseInt(hex.length === 3 ? hex[0] + hex[0] : hex.substring(0, 2), 16);
      G = parseInt(hex.length === 3 ? hex[1] + hex[1] : hex.substring(2, 4), 16);
      B = parseInt(hex.length === 3 ? hex[2] + hex[2] : hex.substring(4, 6), 16);
    } else if (color.startsWith('rgb')) {
      // RGB color - simple extraction (for demo purposes)
      const rgbMatch = color.match(/(\d+),\s*(\d+),\s*(\d+)/);
      if (rgbMatch) {
        R = parseInt(rgbMatch[1]);
        G = parseInt(rgbMatch[2]);
        B = parseInt(rgbMatch[3]);
      } else {
        return color; // Return original if parsing fails
      }
    } else {
      return color; // Return original if format not recognized
    }

    // Calculate shaded values
    R = Math.min(255, Math.max(0, R + R * (percent / 100)));
    G = Math.min(255, Math.max(0, G + G * (percent / 100)));
    B = Math.min(255, Math.max(0, B + B * (percent / 100)));

    // Convert back to hex
    return `#${Math.round(R).toString(16).padStart(2, '0')}${Math.round(G).toString(16).padStart(2, '0')}${Math.round(B).toString(16).padStart(2, '0')}`;
  }


  //   ngOnInit(): void {
  //     this.setFavicon();
  //     this.setMetaTags();
  //     this.titleService.setTitle(environment.title);
  //     this.title.setTitle(environment.title);
  //     this.meta.addTags([
  //       { name: 'description', content: 'Your dynamic description here' },
  //       { property: 'og:title', content: environment.title },
  //       {
  //         property: 'og:description',
  //         content: `${environment.title} LMS is an innovative learning platform designed for healthcare professionals, providing access to interactive medical courses, certification programs, and continuous education. Stay updated with the latest advancements in medicine and enhance your skills with flexible, on-demand learning.`
  //       },
  //       { property: 'og:url', content: window.location.href }
  //     ]);
  //   }
  //   private setFavicon(): void {
  //   const cachedData = localStorage.getItem('tenantUI');
  //   let faviconUrl = 'assets/default-favicon.ico';
  //   let logoWidth: string | null = null;
  //   let logoHeight: string | null = null;

  //   if (cachedData) {
  //     try {
  //       const tenantUI = JSON.parse(cachedData);
  //       const branding = tenantUI?.data?.portalConfig?.branding;

  //       if (branding?.logo?.url) {
  //         faviconUrl = branding.logo.url;
  //       }
  //       if (branding?.logo?.width) {
  //         logoWidth = branding.logo.width;
  //       }
  //       if (branding?.logo?.height) {
  //         logoHeight = branding.logo.height;
  //       }

  //       console.log('Logo from localStorage:', {
  //         faviconUrl,
  //         logoWidth,
  //         logoHeight
  //       });
  //     } catch (error) {
  //       console.error('Error parsing tenantUI from localStorage:', error);
  //     }
  //   }

  //   // Favicon setup (width/height here won’t affect browser rendering)
  //   const link: HTMLLinkElement =
  //     document.querySelector("link[rel*='icon']") || document.createElement('link');
  //   link.type = 'image/x-icon';
  //   link.rel = 'icon';
  //   link.href = faviconUrl;
  //   document.head.appendChild(link);

  //   // ✅ If you want to use width/height elsewhere (like logo <img>), store them in component vars
  //   this.logoWidth = logoWidth || '100px';
  //   this.logoHeight = logoHeight || 'auto';
  // }


  //   setMetaTags(): void {
  //     const meta = environment.meta;

  //     this.metaService.updateTag({ property: 'og:title', content: meta.title });
  //     this.metaService.updateTag({ property: 'og:description', content: meta.description });
  //     this.metaService.updateTag({ property: 'og:image', content: meta.image });
  //     this.metaService.updateTag({ property: 'og:url', content: meta.url });
  //     this.metaService.updateTag({ property: 'og:type', content: meta.type });

  //     // Also update standard description tag
  //     this.metaService.updateTag({ name: 'description', content: meta.description });
  //   }



  callSessionApi(): void {
    this.baseServicesService.callSessionApi().subscribe({
      next: (response: any) => {
        const uuid = response?.uuid;
        this.baseServicesService.setSessionUuid(uuid);
        if (uuid) {
          this.loggingService.log(`Session API called successfully from app component: ${uuid}`);
        } else {
          this.loggingService.warn('UUID not found in the response.');
        }
      },
      error: (error) => {
        this.loggingService.error('Error calling session API', error);
      },
    });
  }

}
